import { render, staticRenderFns } from "./sale_settlement.vue?vue&type=template&id=82008482&scoped=true&"
import script from "./sale_settlement.vue?vue&type=script&lang=js&"
export * from "./sale_settlement.vue?vue&type=script&lang=js&"
import style0 from "./sale_settlement.vue?vue&type=style&index=0&id=82008482&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82008482",
  null
  
)

export default component.exports